import React from 'react';

function ButtonInfo({ onClick, classes, name, disabled }) {
  return (
    <button
      onClick={onClick}
      className={['button-info', classes].join(' ')}
      disabled={disabled}
    >
      {name}
    </button>
  );
}

export default ButtonInfo;
